<template>
  <div class="content">
    <div
      v-if="content.date"
      class="date-holder">
      <span class="date">{{ content.date }}</span>
    </div>
    <span v-html="content.text" />
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
  .content {
    position: relative;
    margin-top: 400px;
    padding: 30px;
    color: #303030;
    line-height: 22px;
    background-color: #FFF;

    @include desktop {
      font-weight: bold;
    }
  }
  .date-holder {
    width: 100%;
    position: absolute;
    top: -11px;
    left: 0;
    text-align: center;
  }

  .date {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    color: white;
    background-color: black;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/TextComponent.vue